import { Stack } from '@mui/material';
import { Title } from './Title';
import { RequestSharePanel } from './RequestSharePanel';
import { useIsDesktop } from 'Hooks';
import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';

interface ISummary {
  data: ITherapySuppliersResult;
}
export const Summary = ({ data }: ISummary) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        mb: isDesktop ? undefined : '24px',
      }}
    >
      <Title
        name={data.name}
        professionId={data.proffessions[0]}
        specialties={data.specialties}
      />
      {isDesktop && <RequestSharePanel data={data} />}
    </Stack>
  );
};
